<template lang="pug">
  toggle-button(:value="isChecked", @change="toggle", :labels="true", :sync="true")
</template>

<script>
import axios from '../../plugins/axios'
export default {
    props: {
        isActive: { type: Boolean, default: false },
        url: { type: String, default: '' },
    },
    data() {
        return {
            isChecked: false,
        };
    },
    methods: {
        async toggle(e){
            axios.post(this.url, {active: this.isChecked})
                .then((res) => {
                    this.isChecked = res.data
                })
                .catch((err) => {
                    const dummyEvent = {
                      preventDefault: () => {}
                    };

                    if(this.url.includes('/api/v1/heatmaps/change_active/')) {
                      window.users_vue_app.openModalServiceLimit(dummyEvent)
                    }
                })
        },
    },
    mounted(){
        this.isChecked = this.isActive
    },
};
</script>
